import {
  ClientReviewStatusV1Schema,
  AgencyChangeRequestTransitionRequestV1Schema,
  AgencyChangeRequestTransitionResultV1Schema,
  type ClientReviewStatusV1,
  type AgencyChangeRequestTransitionRequestV1,
  type AgencyChangeRequestTransitionResultV1,
} from "@enrein/shared-contracts/approval-change";
import {
  BusinessGraphActivationResultV1Schema,
  BusinessGraphActiveViewV1Schema,
  BusinessGraphDraftViewV1Schema,
  BusinessGraphValidationResultV1Schema,
  ProjectCreateResultV1Schema,
  StudioBusinessGraphStatusV1Schema,
  type BusinessGraphActivationResultV1,
  type BusinessGraphActiveViewV1,
  type BusinessGraphDraftViewV1,
  type BusinessGraphValidationResultV1,
  type ProjectCreateResultV1,
  type StudioBusinessGraphStatusV1,
} from "@enrein/shared-contracts/studio-project-workflow";
import {
  BusinessProfileReadinessV1Schema,
  ClientLinkCreateResultV1Schema,
  ClientLinkReissueResultV1Schema,
  type BusinessGraphV1,
  type BusinessProfileReadinessV1,
  type ClientLinkCreateResultV1,
  type ClientLinkReissueResultV1,
  type PackPin,
  type SitePackageId,
  ClarificationActionResultV1Schema,
  ClarificationListV1Schema,
  StudioAssignableUserListV1Schema,
  StudioIntakeSummaryV1Schema,
  StudioProjectLifecycleSummaryV1Schema,
  StudioProjectLifecycleViewV1Schema,
  StudioWorkItemListV1Schema,
  StudioWorkItemMutationResultV1Schema,
  AgencyStudioOnboardingViewV1Schema,
  AgencyStudioOnboardingUpsertV1Schema,
  type AgencyStudioOnboardingViewV1,
  type AgencyStudioOnboardingUpsertV1,
  type ClarificationActionResultV1,
  type ClarificationCreateRequestV1,
  type ClarificationListV1,
  type StudioAssignableUserListV1,
  type StudioIntakeSummaryV1,
  type StudioProjectLifecycleSummaryV1,
  type StudioProjectLifecycleViewV1,
  type StudioWorkItemAssignRequestV1,
  type StudioWorkItemCreateRequestV1,
  type StudioWorkItemListV1,
  type StudioWorkItemMutationResultV1,
} from "@enrein/shared-contracts";
import {
  AgencyEditorPatchAttemptSummaryV1Schema,
  AgencyEditorPatchOutcomeV1Schema,
  AgencyEditorPatchV1Schema,
  InternalReportViewV1Schema,
  InternalLaunchProofViewV1Schema,
  ReportGenerateRequestV1Schema,
  ReportGenerateResultV1Schema,
  StudioDepartureKitStatusV1Schema,
  StudioSafeEditPresentationV1Schema,
  BusinessGraphDiffResultV1Schema,
  InternalGovernanceViewV1Schema,
  ActivityTimelineViewV1Schema,
  AgencyLaunchCertificateViewV1Schema,
  AgencyWebsiteOwnershipViewV1Schema,
  WebsiteOwnershipChecklistUpdateV1Schema,
  PublicScanCreateResultV1Schema,
  PublicScanRequestV1Schema,
  PublicScanStatusV1Schema,
  ConfirmationQueueListV1Schema,
  ImportDraftReviewViewV1Schema,
  SubmitImportSuggestionDecisionsRequestV1Schema,
  ApplyConfirmedToDraftRequestV1Schema,
  ApplyConfirmedToDraftResultV1Schema,
  type InternalGovernanceViewV1,
  type ActivityTimelineViewV1,
  type AgencyEditorPatchAttemptSummaryV1,
  type AgencyEditorPatchOutcomeV1,
  type AgencyEditorPatchV1,
  type InternalReportViewV1,
  type InternalLaunchProofViewV1,
  type ReportGenerateResultV1,
  type StudioDepartureKitStatusV1,
  type StudioSafeEditPresentationV1,
  type BusinessGraphDiffResultV1,
  type AgencyLaunchCertificateViewV1,
  type AgencyWebsiteOwnershipViewV1,
  type WebsiteOwnershipChecklistUpdateV1,
  type PublicScanCreateResultV1,
  type PublicScanStatusV1,
  type ConfirmationQueueListV1,
  type ImportDraftReviewViewV1,
  type SubmitImportSuggestionDecisionsRequestV1,
  type ApplyConfirmedToDraftRequestV1,
  type ApplyConfirmedToDraftResultV1,
} from "@enrein/shared-contracts";
import {
  StudioProjectSummaryV1Schema,
  StudioRunDetailV1Schema,
  StudioRunRowV1Schema,
  StudioMissionControlSummaryV1Schema,
  StudioCreateRunResultV1Schema,
  StudioProjectPreviewV1Schema,
  type StudioProjectSummaryV1,
  type StudioRunDetailV1,
  type StudioRunRowV1,
  type StudioMissionControlSummaryV1,
  type StudioCreateRunResultV1,
  type StudioProjectPreviewV1,
} from "@enrein/shared-contracts/studio-dashboard";
import {
  AgencyPublicScanOpportunityListV1Schema,
  AgencyPublicScanOpportunityV1Schema,
  PublicReportClaimResultV1Schema,
  type AgencyPublicScanOpportunityListV1,
  type AgencyPublicScanOpportunityV1,
  type PublicReportClaimResultV1,
} from "@enrein/shared-contracts/contracts/agency-unlock";
import {
  AgencyFixKitViewV1Schema,
  FixKitGenerateAcceptedV1Schema,
  ManualPaymentUpdateRequestV1Schema,
  type AgencyFixKitViewV1,
  type ManualPaymentUpdateRequestV1,
} from "@enrein/shared-contracts/contracts/fix-kit";
import {
  AgencyRelaunchPreviewViewV1Schema,
  RelaunchPreviewGenerateAcceptedV1Schema,
  type AgencyRelaunchPreviewViewV1,
} from "@enrein/shared-contracts/contracts/relaunch-preview";
import {
  BatchAuditBatchListV1Schema,
  BatchAuditBatchViewV1Schema,
  BatchAuditUploadAcceptedV1Schema,
  type BatchAuditBatchListV1,
  type BatchAuditBatchViewV1,
} from "@enrein/shared-contracts/contracts/batch-audit";
import {
  PilotOutreachCreateRequestV1Schema,
  PilotOutreachListV1Schema,
  PilotOutreachRecordV1Schema,
  type PilotOutreachCreateRequestV1,
  type PilotOutreachListV1,
  type PilotOutreachRecordV1,
} from "@enrein/shared-contracts/contracts/pilot-outreach";
import {
  AgencyPortfolioSummaryV1Schema,
  SalesRoomClientSafeSnapshotV1Schema,
  type SalesRoomClientSafeSnapshotV1,
} from "@enrein/shared-contracts";
import type { StudioRuntimeConfig } from "./env.js";
import {
  ExternalSiteAttachResultV1Schema,
  GenerateExternalReadinessRequestV1Schema,
  GenerateExternalReadinessResultV1Schema,
  type ExternalSiteAttachResultV1,
  type GenerateExternalReadinessResultV1,
  type StudioProjectModeV1,
} from "@enrein/shared-contracts";
import {
  GenerateExternalProofSalesRoomRequestV1Schema,
  GenerateExternalProofSalesRoomResultV1Schema,
  GenerateExternalProofFixKitRequestV1Schema,
  GenerateExternalProofFixKitResultV1Schema,
  ProjectRecordCenterAgencyViewV1Schema,
  type GenerateExternalProofSalesRoomResultV1,
  type GenerateExternalProofFixKitResultV1,
  type ProjectRecordCenterAgencyViewV1,
  StudioBusinessListResponseSchema,
  StudioBusinessRecordSchema,
  StudioTodayResponseSchema,
  type StudioBusinessListResponseV1,
  type StudioBusinessRecordV1,
  type StudioTodayResponse,
} from "@enrein/shared-contracts";

const STUDIO_DEV_AGENCY_HEADER = "X-Enrein-Studio-Dev-Agency-Id";

export type Step5RoomTruthV1 = {
  readonly schemaId: "step5.roomTruth.v1";
  readonly projectId: string;
  readonly businessName: string | null;
  readonly status: string;
  readonly clientAccess: {
    readonly exists: boolean;
    readonly clientLinkId: string | null;
    readonly status: string | null;
  };
  readonly intake: {
    readonly submitted: boolean;
    readonly clientLinkId: string | null;
    readonly businessName: string | null;
    readonly primaryPhone: string | null;
    readonly primaryEmail: string | null;
    readonly description: string | null;
    readonly services: unknown;
    readonly serviceAreas: unknown;
    readonly primaryEvidenceType?: string | null;
  } | null;
  readonly draft: {
    readonly draftId: string;
    readonly draftVersion: number;
    readonly draftSnapshotHash: string;
    readonly status: string;
    readonly confirmationId: string | null;
    readonly description?: string | null;
  } | null;
  readonly confirmationId: string | null;
  readonly currentBusinessGraphRevisionId: string | null;
  readonly generationSelectionVersion: number;
  readonly sitePackageId: string | null;
  readonly latestRun: { readonly runId: string; readonly status: string } | null;
  readonly versions: {
    readonly working: string | null;
    readonly clientVisible: string | null;
    readonly approved: string | null;
    readonly live: string | null;
  };
  readonly approval: {
    readonly approvalId: string;
    readonly approvedAt: string;
    readonly runId: string;
  } | null;
  readonly changeRequest: {
    readonly changeRequestId: string;
    readonly status: string;
    readonly message?: string | null;
  } | null;
  readonly previewUrl: string | null;
  readonly startBuildBlocker?: string | null;
  readonly lifecycleVersion?: number;
  readonly deliveryDueAt?: string | null;
};

export interface StudioApiClient {
  readonly listProjectSummaries: () => Promise<StudioProjectSummaryV1[]>;
  readonly listProjectLifecycleSummaries: () => Promise<StudioProjectLifecycleSummaryV1[]>;
  readonly getProjectLifecycle: (projectId: string) => Promise<StudioProjectLifecycleViewV1>;
  readonly listRuns: (projectId: string) => Promise<StudioRunRowV1[]>;
  readonly getRunDetail: (projectId: string, runId: string) => Promise<StudioRunDetailV1>;
  readonly getProjectPreview: (projectId: string, route?: string) => Promise<StudioProjectPreviewV1>;
  readonly createProject: (input: {
    readonly projectId?: string;
    readonly businessName: string;
    readonly projectMode?: StudioProjectModeV1;
    readonly clientEntityName: string;
    readonly scopeSummary: string;
    readonly ownerLabel: string;
    readonly builderPath: "ENREIN_GENERATE" | "EXTERNAL_SUPPORTED";
    readonly sitePackageId: string;
    readonly targetOutcome: string;
    readonly businessId?: string;
  }) => Promise<ProjectCreateResultV1>;
  readonly listStudioBusinesses: () => Promise<StudioBusinessListResponseV1>;
  readonly getStudioBusiness: (businessId: string) => Promise<StudioBusinessRecordV1>;
  readonly createStudioBusiness: (input: {
    readonly displayName: string;
    readonly clientEntityName?: string;
    readonly businessId?: string;
  }) => Promise<StudioBusinessRecordV1>;
  readonly getStudioToday: () => Promise<StudioTodayResponse>;
  readonly getStudioProjectPipeline: () => Promise<{
    readonly agencyId: string;
    readonly items: ReadonlyArray<{
      readonly projectId: string;
      readonly businessName?: string;
      readonly status?: string;
      readonly stage?: string;
      readonly clientLinkStatus?: string | null;
      readonly draftStatus?: string | null;
      readonly hasConfirmation?: boolean;
      readonly generating?: boolean;
      readonly latestRunStatus?: string | null;
      readonly buildEligible?: boolean;
    }>;
  }>;
  readonly getStudioPortfolio: () => Promise<{
    readonly agencyId: string;
    readonly items: ReadonlyArray<{ readonly projectId?: string; readonly businessName?: string }>;
  }>;
  readonly createStudioQuickNote: (
    projectId: string,
    body: string,
    idempotencyKey: string,
  ) => Promise<{ readonly note?: unknown; readonly message?: string }>;
  readonly confirmBusinessGraphDraft: (
    projectId: string,
    draftId: string,
    input: {
      readonly expectedDraftVersion: number;
      readonly expectedDraftSnapshotHash: string;
      readonly expectedPredecessorRevisionId: string | null;
      readonly idempotencyKey: string;
    },
  ) => Promise<{ readonly message?: string }>;
  readonly startConfirmedBuild: (
    projectId: string,
    confirmationId: string,
    input: Record<string, unknown>,
    idempotencyKey: string,
  ) => Promise<{ readonly message?: string; readonly dispatchState?: string | null; readonly run?: { readonly runId?: string } }>;
  readonly getStep5RoomTruth: (projectId: string) => Promise<Step5RoomTruthV1>;
  readonly patchDeliveryDueAt: (
    projectId: string,
    input: { readonly deliveryDueAt: string | null; readonly expectedLifecycleVersion: number },
    idempotencyKey: string,
  ) => Promise<{ readonly deliveryDueAt?: string | null; readonly lifecycleVersion?: number }>;
  readonly transitionChangeRequest: (
    projectId: string,
    changeRequestId: string,
    input: AgencyChangeRequestTransitionRequestV1,
    idempotencyKey?: string,
  ) => Promise<AgencyChangeRequestTransitionResultV1>;
  readonly createInitialCurrentDraft: (
    projectId: string,
    businessGraph: unknown,
    idempotencyKey: string,
  ) => Promise<{
    readonly draftId: string;
    readonly draftVersion: number;
    readonly draftSnapshotHash: string;
    readonly replayed: boolean;
  }>;
  readonly patchGenerationSelection: (
    projectId: string,
    input: { readonly expectedGenerationSelectionVersion: number; readonly sitePackageId?: string },
    idempotencyKey: string,
  ) => Promise<{ readonly generationSelectionVersion?: number }>;
  readonly listProjectNotes: (projectId: string) => Promise<{ readonly notes: ReadonlyArray<{ readonly noteId?: string; readonly body?: string; readonly noteType?: string; readonly updatedAt?: string }> }>;
  readonly createProjectNote: (
    projectId: string,
    input: { readonly noteType: "INTERNAL" | "TASK"; readonly body: string },
    idempotencyKey: string,
  ) => Promise<{ readonly note?: unknown }>;
  readonly listProjectActivity: (projectId: string) => Promise<{ readonly items: ReadonlyArray<{ readonly eventType?: string; readonly occurredAt?: string; readonly payloadSummary?: string }> }>;
  readonly createBusinessGraphDraft: (
    projectId: string,
    input: {
      readonly businessName: string;
      readonly primaryPhone?: string;
      readonly primaryEmail?: string;
      readonly serviceAreas?: ReadonlyArray<{ readonly id?: string; readonly name: string }>;
      readonly services?: ReadonlyArray<{ readonly id?: string; readonly name: string }>;
    },
  ) => Promise<BusinessGraphDraftViewV1>;
  readonly updateBusinessGraphDraft: (
    projectId: string,
    draftId: string,
    input: {
      readonly businessName?: string;
      readonly primaryPhone?: string | null;
      readonly primaryEmail?: string | null;
      readonly description?: string | null;
      readonly serviceAreas?: ReadonlyArray<{ readonly id?: string; readonly name: string }>;
      readonly services?: ReadonlyArray<{ readonly id?: string; readonly name: string }>;
    },
  ) => Promise<BusinessGraphDraftViewV1>;
  readonly validateBusinessGraphDraft: (projectId: string, draftId: string) => Promise<BusinessGraphValidationResultV1>;
  readonly activateBusinessGraphDraft: (projectId: string, draftId: string) => Promise<BusinessGraphActivationResultV1>;
  readonly getBusinessGraphStatus: (projectId: string) => Promise<StudioBusinessGraphStatusV1>;
  readonly getActiveBusinessGraph: (projectId: string) => Promise<BusinessGraphActiveViewV1>;
  readonly getBusinessGraphDiff: (
    projectId: string,
    fromRevisionId: string,
    toRevisionId: string,
  ) => Promise<BusinessGraphDiffResultV1>;
  readonly listClarifications: (projectId: string) => Promise<ClarificationListV1>;
  readonly createClarification: (
    projectId: string,
    body: ClarificationCreateRequestV1,
  ) => Promise<ClarificationActionResultV1>;
  readonly resolveClarification: (
    projectId: string,
    clarificationRequestId: string,
    body: {
      schemaVersion: "clarification-resolve.v1.0";
      outcome: "RESOLVED" | "REJECTED";
      expectedLifecycleVersion: number;
    },
  ) => Promise<ClarificationActionResultV1>;
  readonly listStudioWorkItems: (projectId: string) => Promise<StudioWorkItemListV1>;
  readonly listAssignableAgencyUsers: (projectId: string) => Promise<StudioAssignableUserListV1>;
  readonly getAgencyStudioOnboarding: () => Promise<AgencyStudioOnboardingViewV1>;
  readonly upsertAgencyStudioOnboarding: (
    body: AgencyStudioOnboardingUpsertV1,
  ) => Promise<AgencyStudioOnboardingViewV1>;
  readonly createStudioWorkItem: (
    projectId: string,
    body: StudioWorkItemCreateRequestV1,
  ) => Promise<StudioWorkItemMutationResultV1>;
  readonly assignStudioWorkItem: (
    projectId: string,
    workItemId: string,
    body: StudioWorkItemAssignRequestV1,
  ) => Promise<StudioWorkItemMutationResultV1>;
  readonly createRun: (
    projectId: string,
    input: {
      readonly businessGraph: BusinessGraphV1;
      readonly recipeId: string;
      readonly packPin: PackPin;
      readonly sitePackageId?: string;
      readonly agencyRequestedSitePackageId?: string;
      readonly idempotencyKey?: string;
    },
  ) => Promise<StudioCreateRunResultV1>;
  readonly createClientLink: (
    projectId: string,
    input?: { readonly clientDisplayName?: string },
  ) => Promise<ClientLinkCreateResultV1>;
  readonly reissueClientLink: (projectId: string) => Promise<ClientLinkReissueResultV1>;
  readonly getMissionControlSummary: () => Promise<StudioMissionControlSummaryV1>;
  readonly getAgencyPortfolioSummary: () => Promise<import("@enrein/shared-contracts").AgencyPortfolioSummaryV1>;
  readonly getSalesRoomSnapshot: (
    projectId: string,
    runId: string,
  ) => Promise<SalesRoomClientSafeSnapshotV1>;
  readonly getClientReviewStatus: (projectId: string) => Promise<ClientReviewStatusV1>;
  readonly submitAgencyEditorPatch: (
    projectId: string,
    patch: AgencyEditorPatchV1,
  ) => Promise<AgencyEditorPatchOutcomeV1>;
  readonly getAgencyEditorPatchStatus: (
    projectId: string,
    patchId: string,
  ) => Promise<AgencyEditorPatchOutcomeV1>;
  readonly listAgencyEditorPatchAttempts: (
    projectId: string,
  ) => Promise<readonly AgencyEditorPatchAttemptSummaryV1[]>;
  readonly getSafeEditPresentation: (projectId: string) => Promise<StudioSafeEditPresentationV1>;
  readonly generateReport: (projectId: string) => Promise<ReportGenerateResultV1>;
  readonly getCurrentInternalReport: (projectId: string) => Promise<InternalReportViewV1>;
  readonly getCurrentInternalLaunchProof: (projectId: string) => Promise<InternalLaunchProofViewV1>;
  readonly getDepartureKitStatus: (projectId: string) => Promise<StudioDepartureKitStatusV1>;
  readonly requestRunExport: (runId: string, projectId: string) => Promise<{ status: string; runId: string }>;
  readonly downloadDepartureKit: (projectId: string) => Promise<Blob>;
  readonly getGovernance: (projectId: string) => Promise<InternalGovernanceViewV1>;
  readonly getActivityTimeline: (projectId: string) => Promise<ActivityTimelineViewV1>;
  readonly evaluateBusinessProfileReadiness: (
    projectId: string,
    businessGraph: BusinessGraphV1,
    requestedPackage?: SitePackageId,
  ) => Promise<BusinessProfileReadinessV1>;
  readonly claimPublicReport: (publicReportRef: string) => Promise<PublicReportClaimResultV1>;
  readonly listPublicScanOpportunities: () => Promise<AgencyPublicScanOpportunityListV1>;
  readonly getPublicScanOpportunity: (claimId: string) => Promise<AgencyPublicScanOpportunityV1>;
  readonly generateFixKit: (claimId: string) => Promise<AgencyFixKitViewV1>;
  readonly getFixKit: (claimId: string) => Promise<AgencyFixKitViewV1>;
  readonly updateFixKitManualPayment: (
    fixKitId: string,
    body: ManualPaymentUpdateRequestV1,
  ) => Promise<AgencyFixKitViewV1>;
  readonly getCurrentLaunchCertificate: (projectId: string) => Promise<AgencyLaunchCertificateViewV1>;
  readonly getLaunchCertificateHtml: (projectId: string) => Promise<string>;
  readonly getWebsiteOwnershipRecord: (projectId: string) => Promise<AgencyWebsiteOwnershipViewV1>;
  readonly updateWebsiteOwnershipRecord: (
    projectId: string,
    body: WebsiteOwnershipChecklistUpdateV1,
  ) => Promise<AgencyWebsiteOwnershipViewV1>;
  readonly generateRelaunchPreview: (claimId: string) => Promise<AgencyRelaunchPreviewViewV1>;
  readonly getRelaunchPreview: (claimId: string) => Promise<AgencyRelaunchPreviewViewV1>;
  readonly uploadBatchAudit: (urls: readonly string[]) => Promise<{ batchId: string; submittedCount: number }>;
  readonly getBatchAudit: (batchId: string) => Promise<BatchAuditBatchViewV1>;
  readonly listBatchAudits: () => Promise<BatchAuditBatchListV1>;
  readonly listPilotOutreach: () => Promise<PilotOutreachListV1>;
  readonly createPilotOutreach: (body: PilotOutreachCreateRequestV1) => Promise<PilotOutreachRecordV1>;
  readonly downloadPilotOutreachCsv: () => Promise<Blob>;
  readonly getProjectIntakeSummary: (projectId: string) => Promise<StudioIntakeSummaryV1>;
  readonly createDraftFromIntake: (
    projectId: string,
    clientLinkId: string,
  ) => Promise<BusinessGraphDraftViewV1>;
  readonly createPublicScan: (url: string) => Promise<PublicScanCreateResultV1>;
  readonly getPublicScanStatus: (scanId: string) => Promise<PublicScanStatusV1>;
  readonly listImportConfirmationQueue: () => Promise<ConfirmationQueueListV1>;
  readonly getImportDraftReview: (importDraftId: string) => Promise<ImportDraftReviewViewV1>;
  readonly submitImportDraftDecisions: (
    importDraftId: string,
    decisions: SubmitImportSuggestionDecisionsRequestV1,
  ) => Promise<void>;
  readonly applyImportConfirmationToDraft: (
    importDraftId: string,
    body?: ApplyConfirmedToDraftRequestV1,
  ) => Promise<ApplyConfirmedToDraftResultV1>;
  readonly attachExternalSite: (projectId: string, url: string) => Promise<ExternalSiteAttachResultV1>;
  readonly generateExternalReadiness: (
    projectId: string,
    options?: { readonly forceRegenerate?: boolean },
  ) => Promise<GenerateExternalReadinessResultV1>;
  readonly generateExternalProofFixKit: (
    projectId: string,
    options?: { readonly forceRegenerate?: boolean },
  ) => Promise<GenerateExternalProofFixKitResultV1>;
  readonly generateExternalProofSalesRoom: (
    projectId: string,
    options?: { readonly forceRegenerate?: boolean; readonly clientLinkId?: string },
  ) => Promise<GenerateExternalProofSalesRoomResultV1>;
  readonly getProjectRecordCenter: (projectId: string) => Promise<ProjectRecordCenterAgencyViewV1>;
}

interface StudioErrorResponse {
  readonly error?: string;
  readonly status?: string;
  readonly requestedPackage?: string;
  readonly currentReadinessLevel?: string;
  readonly availablePackages?: readonly string[];
  readonly blockedPackages?: readonly string[];
  readonly missingRequirements?: readonly string[];
  readonly hardBlockers?: readonly string[];
  readonly warnings?: readonly string[];
  readonly policyVersion?: string;
  readonly richnessScore?: number;
  readonly minimumRichnessRequired?: number;
  readonly richnessBlockReason?: string;
  readonly packageRequiredFieldBlockReason?: string;
}

/** Structured draft-activate / create-run eligibility block from the API (403). */
export type StudioEligibilityBlockedBody = StudioErrorResponse & {
  readonly status: "ELIGIBILITY_BLOCKED";
  readonly requestedPackage: string;
};

export class StudioEligibilityBlockedError extends Error {
  readonly statusCode: number;
  readonly body: StudioEligibilityBlockedBody;

  constructor(body: StudioEligibilityBlockedBody, statusCode: number) {
    super(formatStudioApiFailure(body, statusCode));
    this.name = "StudioEligibilityBlockedError";
    this.statusCode = statusCode;
    this.body = body;
  }
}

export function isStudioEligibilityBlockedError(error: unknown): error is StudioEligibilityBlockedError {
  return error instanceof StudioEligibilityBlockedError;
}

function asStudioEligibilityBlockedBody(body: unknown): StudioEligibilityBlockedBody | null {
  if (!body || typeof body !== "object") return null;
  const maybe = body as StudioErrorResponse;
  if (maybe.status !== "ELIGIBILITY_BLOCKED") return null;
  if (typeof maybe.requestedPackage !== "string" || maybe.requestedPackage.trim().length === 0) {
    return null;
  }
  return maybe as StudioEligibilityBlockedBody;
}

function formatStudioApiFailure(body: unknown, status: number): string {
  if (body && typeof body === "object") {
    const maybe = body as StudioErrorResponse;
    if (maybe.status === "ELIGIBILITY_BLOCKED") {
      const parts = [
        maybe.packageRequiredFieldBlockReason,
        maybe.richnessBlockReason,
        ...(maybe.hardBlockers ?? []),
        ...(maybe.missingRequirements ?? []),
      ].filter((part): part is string => typeof part === "string" && part.trim().length > 0);
      if (parts.length > 0) {
        return `Package ${maybe.requestedPackage ?? "requested"} blocked: ${parts.join("; ")}`;
      }
      return `Package ${maybe.requestedPackage ?? "requested"} is not eligible for this business profile.`;
    }
    if (typeof maybe.error === "string" && maybe.error.length > 0) {
      return maybe.error;
    }
  }
  return `studio_api_error_${status}`;
}

async function parseJsonOrThrow(res: Response): Promise<unknown> {
  const body = (await res.json()) as unknown;
  if (!res.ok) {
    const eligibilityBlocked = asStudioEligibilityBlockedBody(body);
    if (eligibilityBlocked) {
      throw new StudioEligibilityBlockedError(eligibilityBlocked, res.status);
    }
    throw new Error(formatStudioApiFailure(body, res.status));
  }
  return body;
}

function enc(value: string): string {
  return encodeURIComponent(value);
}

function withCredentials(
  config: StudioRuntimeConfig,
  init: RequestInit = {},
): RequestInit {
  const headers: Record<string, string> = {
    ...((init.headers as Record<string, string> | undefined) ?? {}),
  };
  if (config.useDevAgencyHeader && config.agencyId.length > 0) {
    headers[STUDIO_DEV_AGENCY_HEADER] = config.agencyId;
  }
  return { ...init, credentials: "include", headers };
}

function jsonHeaders(config: StudioRuntimeConfig): Record<string, string> {
  const headers: Record<string, string> = { "Content-Type": "application/json" };
  if (config.useDevAgencyHeader && config.agencyId.length > 0) {
    headers[STUDIO_DEV_AGENCY_HEADER] = config.agencyId;
  }
  return headers;
}

export interface CreateStudioApiClientOptions {
  readonly agencyId?: string;
  readonly fetchImpl?: typeof fetch;
}

export function createStudioApiClient(
  config: StudioRuntimeConfig,
  options?: CreateStudioApiClientOptions | typeof fetch,
): StudioApiClient {
  const resolvedOptions = typeof options === "function" ? { fetchImpl: options } : options;
  const fetchImpl = resolvedOptions?.fetchImpl ?? fetch;
  const agencyId = (resolvedOptions?.agencyId ?? config.agencyId).trim();
  const agency = enc(agencyId);

  return {
    async listProjectSummaries() {
      const res = await fetchImpl(`${config.apiBaseUrl}/v1/agencies/${agency}/project-summaries`, withCredentials(config, { method: "GET" }));
      const body = await parseJsonOrThrow(res);
      return StudioProjectSummaryV1Schema.array().parse(body);
    },

    async listProjectLifecycleSummaries() {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/project-lifecycle-summaries`,
        withCredentials(config, { method: "GET" }),
      );
      const body = await parseJsonOrThrow(res);
      return StudioProjectLifecycleSummaryV1Schema.array().parse(body);
    },

    async getProjectLifecycle(projectId: string) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/lifecycle`,
        withCredentials(config, { method: "GET" }),
      );
      const body = await parseJsonOrThrow(res);
      return StudioProjectLifecycleViewV1Schema.parse(body);
    },

    async listRuns(projectId: string) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/runs`,
        withCredentials(config, { method: "GET" }),
      );
      const body = await parseJsonOrThrow(res);
      return StudioRunRowV1Schema.array().parse(body);
    },

    async getRunDetail(projectId: string, runId: string) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/runs/${enc(runId)}`,
        withCredentials(config, { method: "GET" }),
      );
      const body = await parseJsonOrThrow(res);
      return StudioRunDetailV1Schema.parse(body);
    },

    async getProjectPreview(projectId: string, route?: string) {
      const suffix = route ? `?route=${enc(route)}` : "";
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/preview${suffix}`,
        withCredentials(config, { method: "GET" }),
      );
      const body = await parseJsonOrThrow(res);
      return StudioProjectPreviewV1Schema.parse(body);
    },

    async createProject(input) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects`,
        withCredentials(config, {
          method: "POST",
          headers: jsonHeaders(config),
          body: JSON.stringify({ schemaId: "project.createRequest.v1", ...input }),
        }),
      );
      const body = await parseJsonOrThrow(res);
      return ProjectCreateResultV1Schema.parse(body);
    },

    async createBusinessGraphDraft(projectId, input) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/businessgraph/drafts`,
        withCredentials(config, {
          method: "POST",
          headers: jsonHeaders(config),
          body: JSON.stringify({ schemaId: "businessgraph.draftCreateRequest.v1", ...input }),
        }),
      );
      const body = await parseJsonOrThrow(res);
      return BusinessGraphDraftViewV1Schema.parse(body);
    },

    async updateBusinessGraphDraft(projectId, draftId, input) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/businessgraph/drafts/${enc(draftId)}`,
        withCredentials(config, {
          method: "PATCH",
          headers: jsonHeaders(config),
          body: JSON.stringify({ schemaId: "businessgraph.draftUpdate.v1", ...input }),
        }),
      );
      const body = await parseJsonOrThrow(res);
      return BusinessGraphDraftViewV1Schema.parse(body);
    },

    async validateBusinessGraphDraft(projectId, draftId) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/businessgraph/drafts/${enc(draftId)}/validate`,
        withCredentials(config, { method: "POST", headers: jsonHeaders(config), body: "{}" }),
      );
      const body = await parseJsonOrThrow(res);
      return BusinessGraphValidationResultV1Schema.parse(body);
    },

    async activateBusinessGraphDraft(projectId, draftId) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/businessgraph/drafts/${enc(draftId)}/activate`,
        withCredentials(config, { method: "POST", headers: jsonHeaders(config), body: "{}" }),
      );
      const body = await parseJsonOrThrow(res);
      return BusinessGraphActivationResultV1Schema.parse(body);
    },

    async getBusinessGraphStatus(projectId) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/businessgraph/status`,
        withCredentials(config, { method: "GET" }),
      );
      const body = await parseJsonOrThrow(res);
      return StudioBusinessGraphStatusV1Schema.parse(body);
    },

    async getActiveBusinessGraph(projectId) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/businessgraph/active`,
        withCredentials(config, { method: "GET" }),
      );
      const body = await parseJsonOrThrow(res);
      return BusinessGraphActiveViewV1Schema.parse(body);
    },

    async getBusinessGraphDiff(projectId, fromRevisionId, toRevisionId) {
      const qs = new URLSearchParams({
        fromRevisionId,
        toRevisionId,
      });
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/businessgraph/diff?${qs}`,
        withCredentials(config, { method: "GET" }),
      );
      const body = await parseJsonOrThrow(res);
      return BusinessGraphDiffResultV1Schema.parse(body);
    },

    async listClarifications(projectId) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/clarifications`,
        withCredentials(config, { method: "GET" }),
      );
      const body = await parseJsonOrThrow(res);
      return ClarificationListV1Schema.parse(body);
    },

    async createClarification(projectId, body) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/clarifications`,
        withCredentials(config, {
          method: "POST",
          headers: jsonHeaders(config),
          body: JSON.stringify(body),
        }),
      );
      const json = await parseJsonOrThrow(res);
      return ClarificationActionResultV1Schema.parse(json);
    },

    async resolveClarification(projectId, clarificationRequestId, body) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/clarifications/${enc(clarificationRequestId)}/resolve`,
        withCredentials(config, {
          method: "POST",
          headers: jsonHeaders(config),
          body: JSON.stringify(body),
        }),
      );
      const json = await parseJsonOrThrow(res);
      return ClarificationActionResultV1Schema.parse(json);
    },

    async listStudioWorkItems(projectId) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/work-items`,
        withCredentials(config, { method: "GET" }),
      );
      const body = await parseJsonOrThrow(res);
      return StudioWorkItemListV1Schema.parse(body);
    },

    async listAssignableAgencyUsers(projectId) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/assignable-users`,
        withCredentials(config, { method: "GET" }),
      );
      const body = await parseJsonOrThrow(res);
      return StudioAssignableUserListV1Schema.parse(body);
    },

    async createStudioWorkItem(projectId, body) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/work-items`,
        withCredentials(config, {
          method: "POST",
          headers: jsonHeaders(config),
          body: JSON.stringify(body),
        }),
      );
      const json = await parseJsonOrThrow(res);
      return StudioWorkItemMutationResultV1Schema.parse(json);
    },

    async assignStudioWorkItem(projectId, workItemId, body) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/work-items/${enc(workItemId)}/assign`,
        withCredentials(config, {
          method: "POST",
          headers: jsonHeaders(config),
          body: JSON.stringify(body),
        }),
      );
      const json = await parseJsonOrThrow(res);
      return StudioWorkItemMutationResultV1Schema.parse(json);
    },

    async createRun(projectId, input) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/runs`,
        withCredentials(config, {
          method: "POST",
          headers: jsonHeaders(config),
          body: JSON.stringify({
            agencyId,
            projectId,
            recipeId: input.recipeId,
            businessGraph: input.businessGraph,
            packPin: input.packPin,
            sitePackageId: input.sitePackageId,
            agencyRequestedSitePackageId: input.agencyRequestedSitePackageId,
            idempotencyKey: input.idempotencyKey,
          }),
        }),
      );
      const body = await parseJsonOrThrow(res);
      const parsed = StudioCreateRunResultV1Schema.parse(body);
      return parsed;
    },

    async createClientLink(projectId, input) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/client-links`,
        withCredentials(config, {
          method: "POST",
          headers: jsonHeaders(config),
          body: JSON.stringify({
            schemaId: "client-link.createRequest.v1",
            clientDisplayName: input?.clientDisplayName,
          }),
        }),
      );
      const body = await parseJsonOrThrow(res);
      return ClientLinkCreateResultV1Schema.parse(body);
    },

    async reissueClientLink(projectId) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/client-links/reissue`,
        withCredentials(config, {
          method: "POST",
          headers: jsonHeaders(config),
          body: JSON.stringify({
            schemaId: "client-link.reissueRequest.v1",
          }),
        }),
      );
      const body = await parseJsonOrThrow(res);
      return ClientLinkReissueResultV1Schema.parse(body);
    },

    async getMissionControlSummary() {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/mission-control-summary`,
        withCredentials(config, { method: "GET" }),
      );
      const body = await parseJsonOrThrow(res);
      return StudioMissionControlSummaryV1Schema.parse(body);
    },

    async getAgencyPortfolioSummary() {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/studio-portfolio-summary`,
        withCredentials(config, { method: "GET" }),
      );
      const body = await parseJsonOrThrow(res);
      return AgencyPortfolioSummaryV1Schema.parse(body);
    },

    async getSalesRoomSnapshot(projectId, runId) {
      const params = new URLSearchParams({
        agencyId: agency,
        projectId,
        runId,
      });
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/sales-room/snapshot?${params.toString()}`,
        withCredentials(config, { method: "GET" }),
      );
      const body = await parseJsonOrThrow(res);
      return SalesRoomClientSafeSnapshotV1Schema.parse(body);
    },

    async getClientReviewStatus(projectId) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/client-review-status`,
        withCredentials(config, { method: "GET" }),
      );
      const body = await parseJsonOrThrow(res);
      return ClientReviewStatusV1Schema.parse(body);
    },

    async submitAgencyEditorPatch(projectId, patch) {
      const parsed = AgencyEditorPatchV1Schema.parse(patch);
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/agency-editor-patches`,
        withCredentials(config, {
          method: "POST",
          headers: jsonHeaders(config),
          body: JSON.stringify(parsed),
        }),
      );
      const body = await parseJsonOrThrow(res);
      return AgencyEditorPatchOutcomeV1Schema.parse(body);
    },

    async getAgencyEditorPatchStatus(projectId, patchId) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/agency-editor-patches/${enc(patchId)}/status`,
        withCredentials(config, { method: "GET" }),
      );
      const body = await parseJsonOrThrow(res);
      return AgencyEditorPatchOutcomeV1Schema.parse(body);
    },

    async listAgencyEditorPatchAttempts(projectId) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/agency-editor-patch-attempts`,
        withCredentials(config, { method: "GET" }),
      );
      const body = await parseJsonOrThrow(res);
      return AgencyEditorPatchAttemptSummaryV1Schema.array().parse(body);
    },

    async getSafeEditPresentation(projectId) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/safe-edit-presentation`,
        withCredentials(config, { method: "GET" }),
      );
      const body = await parseJsonOrThrow(res);
      return StudioSafeEditPresentationV1Schema.parse(body);
    },

    async generateReport(projectId) {
      const bodyIn = ReportGenerateRequestV1Schema.parse({
        schemaVersion: "report-generate-request.v1.0",
        reportType: "SEARCH_READINESS",
      });
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/reports/generate`,
        withCredentials(config, {
          method: "POST",
          headers: jsonHeaders(config),
          body: JSON.stringify(bodyIn),
        }),
      );
      const body = await parseJsonOrThrow(res);
      return ReportGenerateResultV1Schema.parse(body);
    },

    async getCurrentInternalReport(projectId) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/reports/current/internal`,
        withCredentials(config, { method: "GET" }),
      );
      const body = await parseJsonOrThrow(res);
      return InternalReportViewV1Schema.parse(body);
    },

    async getCurrentInternalLaunchProof(projectId) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/launch-proof/current/internal`,
        withCredentials(config, { method: "GET" }),
      );
      const body = await parseJsonOrThrow(res);
      return InternalLaunchProofViewV1Schema.parse(body);
    },

    async getDepartureKitStatus(projectId) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/departure-kit/status`,
        withCredentials(config, { method: "GET" }),
      );
      const body = await parseJsonOrThrow(res);
      return StudioDepartureKitStatusV1Schema.parse(body);
    },

    async requestRunExport(runId, projectId) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/runs/${enc(runId)}/export`,
        withCredentials(config, {
          method: "POST",
          headers: jsonHeaders(config),
          body: JSON.stringify({
            agencyId,
            projectId,
          }),
        }),
      );
      const body = (await parseJsonOrThrow(res)) as { status: string; runId: string };
      return body;
    },

    async downloadDepartureKit(projectId) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/departure-kit/download`,
        withCredentials(config, { method: "GET" }),
      );
      if (!res.ok) {
        const body = (await res.json().catch(() => ({}))) as StudioErrorResponse;
        throw new Error(body.error ?? `studio_api_error_${res.status}`);
      }
      return res.blob();
    },

    async getGovernance(projectId) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/governance`,
        withCredentials(config, { method: "GET" }),
      );
      const body = await parseJsonOrThrow(res);
      return InternalGovernanceViewV1Schema.parse(body);
    },

    async getActivityTimeline(projectId) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/activity-timeline`,
        withCredentials(config, { method: "GET" }),
      );
      const body = await parseJsonOrThrow(res);
      return ActivityTimelineViewV1Schema.parse(body);
    },

    async evaluateBusinessProfileReadiness(projectId, businessGraph, requestedPackage) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/business-profile-readiness/evaluate`,
        withCredentials(config, {
          method: "POST",
          headers: jsonHeaders(config),
          body: JSON.stringify({
            agencyId,
            projectId,
            businessGraph,
            requestedPackage,
          }),
        }),
      );
      const body = await parseJsonOrThrow(res);
      return BusinessProfileReadinessV1Schema.parse(body);
    },

    async claimPublicReport(publicReportRef) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/public-reports/${enc(publicReportRef)}/claim`,
        withCredentials(config, { method: "POST" }),
      );
      const body = await parseJsonOrThrow(res);
      return PublicReportClaimResultV1Schema.parse(body);
    },

    async listPublicScanOpportunities() {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/public-scan-opportunities`,
        withCredentials(config, { method: "GET" }),
      );
      const body = await parseJsonOrThrow(res);
      return AgencyPublicScanOpportunityListV1Schema.parse(body);
    },

    async getPublicScanOpportunity(claimId) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/public-scan-opportunities/${enc(claimId)}`,
        withCredentials(config, { method: "GET" }),
      );
      const body = await parseJsonOrThrow(res);
      return AgencyPublicScanOpportunityV1Schema.parse(body);
    },

    async generateFixKit(claimId) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/public-scan-opportunities/${enc(claimId)}/fix-kit/generate`,
        withCredentials(config, { method: "POST" }),
      );
      const body = await res.json();
      if (!res.ok) {
        const maybe = body as StudioErrorResponse;
        throw new Error(maybe.error ?? `studio_api_error_${res.status}`);
      }
      if (res.status === 202) {
        FixKitGenerateAcceptedV1Schema.parse(body);
        for (let attempt = 0; attempt < 30; attempt += 1) {
          await new Promise((resolve) => setTimeout(resolve, 100));
          try {
            return await this.getFixKit(claimId);
          } catch (caught) {
            if (!(caught instanceof Error && caught.message.includes("fix_kit_not_found"))) {
              throw caught;
            }
          }
        }
        throw new Error("fix_kit_pending_timeout");
      }
      return AgencyFixKitViewV1Schema.parse(body);
    },

    async getFixKit(claimId) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/public-scan-opportunities/${enc(claimId)}/fix-kit`,
        withCredentials(config, { method: "GET" }),
      );
      const body = await parseJsonOrThrow(res);
      return AgencyFixKitViewV1Schema.parse(body);
    },

    async updateFixKitManualPayment(fixKitId, bodyIn) {
      const payload = ManualPaymentUpdateRequestV1Schema.parse(bodyIn);
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/fix-kits/${enc(fixKitId)}/manual-payment`,
        withCredentials(config, {
          method: "PATCH",
          headers: jsonHeaders(config),
          body: JSON.stringify(payload),
        }),
      );
      const body = await parseJsonOrThrow(res);
      return AgencyFixKitViewV1Schema.parse(body);
    },

    async getCurrentLaunchCertificate(projectId) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/launch-certificate/current`,
        withCredentials(config, { method: "GET" }),
      );
      const body = await parseJsonOrThrow(res);
      return AgencyLaunchCertificateViewV1Schema.parse(body);
    },

    async getLaunchCertificateHtml(projectId) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/launch-certificate/html`,
        withCredentials(config, { method: "GET" }),
      );
      if (!res.ok) {
        throw new Error(`studio_api_error_${res.status}`);
      }
      return res.text();
    },

    async getWebsiteOwnershipRecord(projectId) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/website-ownership-record`,
        withCredentials(config, { method: "GET" }),
      );
      const body = await parseJsonOrThrow(res);
      return AgencyWebsiteOwnershipViewV1Schema.parse(body);
    },

    async updateWebsiteOwnershipRecord(projectId, bodyIn) {
      const payload = WebsiteOwnershipChecklistUpdateV1Schema.parse(bodyIn);
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/website-ownership-record`,
        withCredentials(config, {
          method: "PATCH",
          headers: jsonHeaders(config),
          body: JSON.stringify(payload),
        }),
      );
      const body = await parseJsonOrThrow(res);
      return AgencyWebsiteOwnershipViewV1Schema.parse(body);
    },

    async generateRelaunchPreview(claimId) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/public-scan-opportunities/${enc(claimId)}/relaunch-preview/generate`,
        withCredentials(config, { method: "POST" }),
      );
      const body = await res.json();
      if (!res.ok) {
        const maybe = body as StudioErrorResponse;
        throw new Error(maybe.error ?? `studio_api_error_${res.status}`);
      }
      if (res.status === 202) {
        RelaunchPreviewGenerateAcceptedV1Schema.parse(body);
        for (let attempt = 0; attempt < 30; attempt += 1) {
          await new Promise((resolve) => setTimeout(resolve, 100));
          try {
            return await this.getRelaunchPreview(claimId);
          } catch (caught) {
            if (!(caught instanceof Error && caught.message.includes("relaunch_preview_not_found"))) {
              throw caught;
            }
          }
        }
        throw new Error("relaunch_preview_pending_timeout");
      }
      return AgencyRelaunchPreviewViewV1Schema.parse(body);
    },

    async getRelaunchPreview(claimId) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/public-scan-opportunities/${enc(claimId)}/relaunch-preview`,
        withCredentials(config, { method: "GET" }),
      );
      const body = await parseJsonOrThrow(res);
      return AgencyRelaunchPreviewViewV1Schema.parse(body);
    },

    async uploadBatchAudit(urls) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/batch-audits`,
        withCredentials(config, {
          method: "POST",
          headers: jsonHeaders(config),
          body: JSON.stringify({
            schemaVersion: "batch-audit-upload.v1.0",
            urls: [...urls],
          }),
        }),
      );
      const body = await parseJsonOrThrow(res);
      const accepted = BatchAuditUploadAcceptedV1Schema.parse(body);
      return { batchId: accepted.batchId, submittedCount: accepted.submittedCount };
    },

    async getBatchAudit(batchId) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/batch-audits/${enc(batchId)}`,
        withCredentials(config, { method: "GET" }),
      );
      const body = await parseJsonOrThrow(res);
      return BatchAuditBatchViewV1Schema.parse(body);
    },

    async listBatchAudits() {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/batch-audits`,
        withCredentials(config, { method: "GET" }),
      );
      const body = await parseJsonOrThrow(res);
      return BatchAuditBatchListV1Schema.parse(body);
    },

    async listPilotOutreach() {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/pilot-outreach`,
        withCredentials(config, { method: "GET" }),
      );
      const body = await parseJsonOrThrow(res);
      return PilotOutreachListV1Schema.parse(body);
    },

    async createPilotOutreach(bodyIn) {
      const payload = PilotOutreachCreateRequestV1Schema.parse(bodyIn);
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/pilot-outreach`,
        withCredentials(config, {
          method: "POST",
          headers: jsonHeaders(config),
          body: JSON.stringify(payload),
        }),
      );
      const body = await parseJsonOrThrow(res);
      return PilotOutreachRecordV1Schema.parse(body);
    },

    async downloadPilotOutreachCsv() {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/pilot-outreach/export.csv`,
        withCredentials(config, { method: "GET" }),
      );
      if (!res.ok) {
        throw new Error(`studio_api_error_${res.status}`);
      }
      return res.blob();
    },

    async getProjectIntakeSummary(projectId) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/intake`,
        withCredentials(config, { method: "GET" }),
      );
      const body = await parseJsonOrThrow(res);
      return StudioIntakeSummaryV1Schema.parse(body);
    },

    async createDraftFromIntake(projectId, clientLinkId) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/intake/draft-from-intake`,
        withCredentials(config, {
          method: "POST",
          headers: jsonHeaders(config),
          body: JSON.stringify({
            schemaId: "studio-intake.draftFromIntakeRequest.v1",
            clientLinkId,
          }),
        }),
      );
      const body = await parseJsonOrThrow(res);
      return BusinessGraphDraftViewV1Schema.parse(body);
    },

    async createPublicScan(url) {
      const payload = PublicScanRequestV1Schema.parse({
        schemaVersion: "public-scan-request.v1.0",
        url,
      });
      const res = await fetchImpl(`${config.apiBaseUrl}/v1/public/scans`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const body = await parseJsonOrThrow(res);
      return PublicScanCreateResultV1Schema.parse(body);
    },

    async getPublicScanStatus(scanId) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/public/scans/${enc(scanId)}/status`,
        { method: "GET" },
      );
      const body = await parseJsonOrThrow(res);
      return PublicScanStatusV1Schema.parse(body);
    },

    async listImportConfirmationQueue() {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/import-confirmation-queue`,
        withCredentials(config, { method: "GET" }),
      );
      const body = await parseJsonOrThrow(res);
      return ConfirmationQueueListV1Schema.parse(body);
    },

    async getImportDraftReview(importDraftId) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/import-drafts/${enc(importDraftId)}/review`,
        withCredentials(config, { method: "GET" }),
      );
      const body = await parseJsonOrThrow(res);
      return ImportDraftReviewViewV1Schema.parse(body);
    },

    async submitImportDraftDecisions(importDraftId, decisions) {
      const payload = SubmitImportSuggestionDecisionsRequestV1Schema.parse(decisions);
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/import-drafts/${enc(importDraftId)}/decisions`,
        withCredentials(config, {
          method: "POST",
          headers: jsonHeaders(config),
          body: JSON.stringify(payload),
        }),
      );
      if (!res.ok) {
        const body = (await res.json().catch(() => ({}))) as StudioErrorResponse;
        throw new Error(body.error ?? `studio_api_error_${res.status}`);
      }
    },

    async applyImportConfirmationToDraft(importDraftId, body = { schemaId: "importConfirmation.applyToDraftRequest.v1" }) {
      const payload = ApplyConfirmedToDraftRequestV1Schema.parse(body);
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/import-drafts/${enc(importDraftId)}/apply-to-draft`,
        withCredentials(config, {
          method: "POST",
          headers: jsonHeaders(config),
          body: JSON.stringify(payload),
        }),
      );
      const parsed = await parseJsonOrThrow(res);
      return ApplyConfirmedToDraftResultV1Schema.parse(parsed);
    },

    async attachExternalSite(projectId, url) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/external-site/attach`,
        withCredentials(config, {
          method: "POST",
          headers: jsonHeaders(config),
          body: JSON.stringify({ schemaId: "externalSite.attachRequest.v1", url }),
        }),
      );
      const body = await parseJsonOrThrow(res);
      return ExternalSiteAttachResultV1Schema.parse(body);
    },

    async generateExternalReadiness(projectId, options) {
      const payload = GenerateExternalReadinessRequestV1Schema.parse({
        schemaId: "externalReadiness.generateRequest.v1",
        forceRegenerate: options?.forceRegenerate,
      });
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/external-readiness/generate`,
        withCredentials(config, {
          method: "POST",
          headers: jsonHeaders(config),
          body: JSON.stringify(payload),
        }),
      );
      const body = await parseJsonOrThrow(res);
      return GenerateExternalReadinessResultV1Schema.parse(body);
    },

    async generateExternalProofFixKit(projectId, options) {
      const payload = GenerateExternalProofFixKitRequestV1Schema.parse({
        schemaId: "externalProofFixKit.generateRequest.v1",
        forceRegenerate: options?.forceRegenerate,
      });
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/external-proof-fix-kit/generate`,
        withCredentials(config, {
          method: "POST",
          headers: jsonHeaders(config),
          body: JSON.stringify(payload),
        }),
      );
      const body = await parseJsonOrThrow(res);
      return GenerateExternalProofFixKitResultV1Schema.parse(body);
    },

    async generateExternalProofSalesRoom(projectId, options) {
      const payload = GenerateExternalProofSalesRoomRequestV1Schema.parse({
        schemaId: "externalProofSalesRoom.generateRequest.v1",
        forceRegenerate: options?.forceRegenerate,
        clientLinkId: options?.clientLinkId,
      });
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/external-proof-sales-room/generate`,
        withCredentials(config, {
          method: "POST",
          headers: jsonHeaders(config),
          body: JSON.stringify(payload),
        }),
      );
      const body = await parseJsonOrThrow(res);
      return GenerateExternalProofSalesRoomResultV1Schema.parse(body);
    },

    async listStudioBusinesses() {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/studio-businesses`,
        withCredentials(config, { method: "GET" }),
      );
      const body = await parseJsonOrThrow(res);
      return StudioBusinessListResponseSchema.parse(body);
    },

    async getStudioBusiness(businessId) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/studio-businesses/${enc(businessId)}`,
        withCredentials(config, { method: "GET" }),
      );
      const body = await parseJsonOrThrow(res);
      return StudioBusinessRecordSchema.parse(body);
    },

    async createStudioBusiness(input) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/studio-businesses`,
        withCredentials(config, {
          method: "POST",
          headers: jsonHeaders(config),
          body: JSON.stringify({ schemaId: "studio.businessCreateRequest.v1", ...input }),
        }),
      );
      const body = await parseJsonOrThrow(res);
      return StudioBusinessRecordSchema.parse(body);
    },

    async getStudioToday() {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/studio-today`,
        withCredentials(config, { method: "GET" }),
      );
      const body = await parseJsonOrThrow(res);
      return StudioTodayResponseSchema.parse(body);
    },

    async getStudioProjectPipeline() {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/studio-project-pipeline`,
        withCredentials(config, { method: "GET" }),
      );
      return (await parseJsonOrThrow(res)) as Awaited<ReturnType<StudioApiClient["getStudioProjectPipeline"]>>;
    },

    async getStudioPortfolio() {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/studio-portfolio`,
        withCredentials(config, { method: "GET" }),
      );
      return (await parseJsonOrThrow(res)) as Awaited<ReturnType<StudioApiClient["getStudioPortfolio"]>>;
    },

    async createStudioQuickNote(projectId, body, idempotencyKey) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/studio-today/quick-note`,
        withCredentials(config, {
          method: "POST",
          headers: { ...jsonHeaders(config), "Idempotency-Key": idempotencyKey },
          body: JSON.stringify({ projectId, body }),
        }),
      );
      return (await parseJsonOrThrow(res)) as { note?: unknown; message?: string };
    },

    async confirmBusinessGraphDraft(projectId, draftId, input) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/businessgraph/drafts/${enc(draftId)}/confirm`,
        withCredentials(config, {
          method: "POST",
          headers: { ...jsonHeaders(config), "Idempotency-Key": input.idempotencyKey },
          body: JSON.stringify({
            expectedDraftVersion: input.expectedDraftVersion,
            expectedDraftSnapshotHash: input.expectedDraftSnapshotHash,
            expectedPredecessorRevisionId: input.expectedPredecessorRevisionId,
          }),
        }),
      );
      return (await parseJsonOrThrow(res)) as { message?: string };
    },

    async getStep5RoomTruth(projectId) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/step5-room-truth`,
        withCredentials(config, { method: "GET" }),
      );
      return (await parseJsonOrThrow(res)) as Step5RoomTruthV1;
    },

    async patchDeliveryDueAt(projectId, input, idempotencyKey) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/delivery-due-at`,
        withCredentials(config, {
          method: "PATCH",
          headers: { ...jsonHeaders(config), "Idempotency-Key": idempotencyKey },
          body: JSON.stringify({
            schemaId: "step5.deliveryDueAtPatchRequest.v1",
            deliveryDueAt: input.deliveryDueAt,
            expectedLifecycleVersion: input.expectedLifecycleVersion,
          }),
        }),
      );
      return (await parseJsonOrThrow(res)) as {
        deliveryDueAt?: string | null;
        lifecycleVersion?: number;
      };
    },

    async transitionChangeRequest(projectId, changeRequestId, input, idempotencyKey) {
      const payload = AgencyChangeRequestTransitionRequestV1Schema.parse(input);
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/change-requests/${enc(changeRequestId)}/transition`,
        withCredentials(config, {
          method: "POST",
          headers: {
            ...jsonHeaders(config),
            ...(idempotencyKey ? { "Idempotency-Key": idempotencyKey } : {}),
          },
          body: JSON.stringify(payload),
        }),
      );
      const body = await parseJsonOrThrow(res);
      return AgencyChangeRequestTransitionResultV1Schema.parse(body);
    },

    async createInitialCurrentDraft(projectId, businessGraph, idempotencyKey) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/businessgraph/drafts/initial`,
        withCredentials(config, {
          method: "POST",
          headers: { ...jsonHeaders(config), "Idempotency-Key": idempotencyKey },
          body: JSON.stringify({
            schemaId: "step5.createInitialDraftRequest.v1",
            source: "CLIENT_INTAKE",
            businessGraph,
          }),
        }),
      );
      return (await parseJsonOrThrow(res)) as {
        draftId: string;
        draftVersion: number;
        draftSnapshotHash: string;
        replayed: boolean;
      };
    },

    async patchGenerationSelection(projectId, input, idempotencyKey) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/generation-selection`,
        withCredentials(config, {
          method: "PATCH",
          headers: { ...jsonHeaders(config), "Idempotency-Key": idempotencyKey },
          body: JSON.stringify(input),
        }),
      );
      return (await parseJsonOrThrow(res)) as { generationSelectionVersion?: number };
    },

    async listProjectNotes(projectId) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/notes`,
        withCredentials(config, { method: "GET" }),
      );
      return (await parseJsonOrThrow(res)) as { notes: Array<{ noteId?: string; body?: string; noteType?: string; updatedAt?: string }> };
    },

    async createProjectNote(projectId, input, idempotencyKey) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/notes`,
        withCredentials(config, {
          method: "POST",
          headers: { ...jsonHeaders(config), "Idempotency-Key": idempotencyKey },
          body: JSON.stringify(input),
        }),
      );
      return (await parseJsonOrThrow(res)) as { note?: unknown };
    },

    async listProjectActivity(projectId) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/activity`,
        withCredentials(config, { method: "GET" }),
      );
      return (await parseJsonOrThrow(res)) as {
        items: Array<{ eventType?: string; occurredAt?: string; payloadSummary?: string }>;
      };
    },

    async startConfirmedBuild(projectId, confirmationId, input, idempotencyKey) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/businessgraph/candidate-confirmations/${enc(confirmationId)}/start-build`,
        withCredentials(config, {
          method: "POST",
          headers: { ...jsonHeaders(config), "Idempotency-Key": idempotencyKey },
          body: JSON.stringify(input),
        }),
      );
      const dispatchState = res.headers.get("X-Enrein-Dispatch-State");
      const body = (await parseJsonOrThrow(res)) as { message?: string };
      return { ...body, dispatchState };
    },

    async getProjectRecordCenter(projectId) {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/projects/${enc(projectId)}/record-center`,
        withCredentials(config, { method: "GET" }),
      );
      const body = await parseJsonOrThrow(res);
      return ProjectRecordCenterAgencyViewV1Schema.parse(body);
    },

    async getAgencyStudioOnboarding() {
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/studio-onboarding`,
        withCredentials(config, { method: "GET" }),
      );
      const body = await parseJsonOrThrow(res);
      return AgencyStudioOnboardingViewV1Schema.parse(body);
    },

    async upsertAgencyStudioOnboarding(body) {
      const payload = AgencyStudioOnboardingUpsertV1Schema.parse(body);
      const res = await fetchImpl(
        `${config.apiBaseUrl}/v1/agencies/${agency}/studio-onboarding`,
        withCredentials(config, {
          method: "PUT",
          headers: jsonHeaders(config),
          body: JSON.stringify(payload),
        }),
      );
      const parsed = await parseJsonOrThrow(res);
      return AgencyStudioOnboardingViewV1Schema.parse(parsed);
    },
  };
}
